import * as types from './action-types';
import initState from './state'

const initialState = initState;

export default (state = initialState, action) => {
  let obj;
  switch (action.type) {
    case types.SET_AUTH_DATA:
      return {
        ...state,
        account: action.payload.data
      };
    case types.ADD_AUTH_DATA:
      obj = state[action.payload.key];
      obj.push(action.payload.data);
      return {
        ...state,
        [action.payload.key]: [...obj]
      };
    case types.DELETE_AUTH_DATA:
      obj = state[action.payload.key];
      obj.splice(action.payload.index, 1);
      return {
        ...state,
        [action.payload.key]: [...obj]
      };
    case types.CHANGE_LANGUAGE:
      return {
        ...state,
        currentLanguage: localStorage.getItem("i18nextLng").substr(0, 2)
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/reducers.js